/**
 * desc 添加车辆的表格
 * 功能：可添加车辆信息，修改价格，进行数据顺序调整
 * */
import React, { Component } from 'react';
import { Form, Button, Table, Icon, message, Modal, Upload } from 'antd';
import clazz from 'classnames';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import EditableCell, { EditableFormRow } from './TableCell';
import ColorTag from './ColorTag';
import AddCarModal from './AddCarModal';
import { showInfo } from '@/components';
import { dealValueShow, dealListValueShow, dealCarNum, getDataType } from '@/shared/functions';
import { fontEndConfig, showCarDetail } from '@/shared/utils';
import styles from '../_style/index.less';
import { CHECK_Money7, CHECK_percent } from '@/shared/reqexp';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class AddCarTable extends Component {
    constructor(props) {
        super(props);
        this.updateTimer = null;
        this.state = {
            brokerageUnit: null,
            carTable: [
                {
                    title: '序号',
                    align: 'center',
                    width: 60,
                    dataIndex: 'auctionSerialNumber',
                    className: clazz(styles.tdPosition),
                    onCell: (rowData, index) => {
                        return {
                            td: {
                                rowData,
                                formTable: this.props.form,
                                editable: this.props.session.editIndex,
                                tdType: 'editableIndex',
                                dataIndex: 'auctionSerialNumber',
                                tdClassName: styles.test,
                            },
                        };
                    },
                    render: (num, rowData) => {
                        return (<React.Fragment>
                <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            overflow: 'hidden',
                            width: '50px',
                            height: '50px',
                        }}>
                  {rowData.status === 1 && <div className={styles.tag}>已下架</div>}
                </div>
                <span>
                  {rowData.status === 0 ? dealCarNum(num) : '--'}
                </span>
              </React.Fragment>);
                    },
                },
                {
                    title: '车辆信息',
                    width: 200,
                    align: 'left',
                    dataIndex: 'carModelName',
                    className: clazz(styles.carModal, styles.tdNoPadding),
                    render: (carModelName, record, index) => {
                        let state = fontEndConfig.noValueReplace;
                        let tagColorCar = '#999999';
                        switch (record.auctionStatus) {
                            case 1:
                                state = '预展中';
                                tagColorCar = '#1DBF6E';
                                break;
                            case 2:
                                state = '待开拍';
                                tagColorCar = '#4DA6FF';
                                break;
                            case 3:
                                state = '竞拍中';
                                tagColorCar = '#FF571A';
                                break;
                            case 4:
                                state = '结束';
                                tagColorCar = '#999999';
                                break;
                            case 5:
                                state = '已成交';
                                tagColorCar = '#FF4040';
                                break;
                            case 6:
                                state = '流拍';
                                tagColorCar = '#999999';
                                break;
                            case 7:
                                state = '已下架';
                                tagColorCar = '#999999';
                                break;
                            case 9:
                                state = '投标中';
                                tagColorCar = '#FFA815';
                                break;
                            case 50:
                                state = '待成交';
                                tagColorCar = '#4DA6FF';
                                break;
                        }
                        const level = record.rankLevel === fontEndConfig.noValueReplace ? '' : record.rankLevel;
                        const levelA = record.rankDesc === fontEndConfig.noValueReplace ? '' : record.rankDesc;
                        return (<div>
                <div>
                  <a onClick={() => {
                            showCarDetail(record.goodsId);
                        }}>
                    {carModelName}
                  </a>
                </div>
                <div>{`VIN码：${record.vin}`}</div>
                <div>
                  {state !== fontEndConfig.noValueReplace && <ColorTag color={'#FFFFFF'} background={tagColorCar}>
                      {state}
                    </ColorTag>}
                  <ColorTag color={'#FF571A'} background={'rgba(255,87,25,0.1)'}>
                    {record.license}
                  </ColorTag>
                  <ColorTag background={'#FDF1DF'} color={'#F19D27'}>
                    {dealValueShow((level + levelA) === 'undefined' ? '' : (level + levelA), false, fontEndConfig.noValueReplace)}
                  </ColorTag>
                  <ColorTag color={'#4DA6FF'} background={'rgba(77,166,255,0.1)'}>
                    {record.locationName}
                  </ColorTag>
                </div>
              </div>);
                    },
                },
                {
                    title: '卖家经销商',
                    width: 90,
                    align: 'left',
                    dataIndex: 'sellerCode',
                    className: clazz(styles.carModal, styles.tdNoPadding),
                    render: (text, record, index) => text === fontEndConfig.noValueReplace ?
                        <span>{text}</span> : (<a href="javascript:;" onClick={() => {
                        showInfo('seller', record.sellerCode);
                    }}>
                {record.sellerName}
              </a>),
                },
                {
                    title: '价格信息/元',
                    width: 180,
                    align: 'left',
                    dataIndex: 'buyPriceY',
                    className: clazz(styles.tdNoPadding),
                    onCell: (rowData, index) => ({
                        td: {
                            tdType: 'editablePrice',
                            renderData: [
                                // {
                                //   editable: false,
                                //   tdType: 'editable',
                                //   title: '收购价',
                                //   rowData,
                                //   dataIndex: 'buyPriceY',
                                // },
                                {
                                    editable: this.isEdit(rowData.goodsId),
                                    tdType: 'editable',
                                    title: '保留价',
                                    rowData,
                                    dataIndex: 'basePriceY',
                                    checkRule: () => {
                                        return [
                                            {
                                                validator: (rule, value, callback) => {
                                                    const auctionMode = this.props.Form.getFieldsValue(['auctionMode'])['auctionMode'];
                                                    if (auctionMode === 1001) {
                                                        if (value) {
                                                            callback();
                                                        }
                                                        else {
                                                            callback('请输入保留价');
                                                        }
                                                    }
                                                    else {
                                                        callback();
                                                    }
                                                },
                                            },
                                            {
                                                pattern: CHECK_Money7,
                                                message: '请输入不超过七位数的整百数',
                                            },
                                        ];
                                    },
                                },
                                {
                                    editable: this.isEdit(rowData.goodsId),
                                    tdType: 'editable',
                                    title: '起拍价',
                                    rowData,
                                    dataIndex: 'auctionPriceY',
                                    checkRule: () => {
                                        return [
                                            {
                                                validator: (rule, value, callback) => {
                                                    const auctionMode = this.props.Form.getFieldsValue(['auctionMode'])['auctionMode'];
                                                    if (auctionMode === 1001) {
                                                        if (value) {
                                                            callback();
                                                        }
                                                        else {
                                                            callback('请输入起拍价');
                                                        }
                                                    }
                                                    else {
                                                        callback();
                                                    }
                                                },
                                            },
                                            {
                                                pattern: CHECK_Money7,
                                                message: '请输入不超过七位数的整百数',
                                            },
                                        ];
                                    },
                                },
                            ],
                        },
                    }),
                },
                {
                    title: '成交信息',
                    dataIndex: 'goodsId',
                    width: 80,
                    render: (goodsId) => {
                        return (<a onClick={() => {
                            this.showTransferDetail(goodsId);
                        }}>
                查看
              </a>);
                    },
                },
                {
                    title: '佣金',
                    align: 'left',
                    dataIndex: 'brokerage',
                    width: 100,
                    onCell: (rowData, index) => ({
                        td: {
                            editable: this.judgeSessionState(0) && this.isEdit(rowData.goodsId) && rowData.brokerageTag !== 2,
                            tdType: 'editable',
                            rowData,
                            dataIndex: 'brokerage',
                            formKeyFn: (rowData) => {
                                if (rowData.brokerageTag === 0) {
                                    return 'brokerageY';
                                }
                                return 'brokerage';
                            },
                            checkRule: (rowData) => {
                                if (rowData.brokerageTag === 0) {
                                    return [
                                        {
                                            pattern: CHECK_Money7,
                                            message: '请输入不超过七位数的整百数',
                                        },
                                    ];
                                }
                                return [{
                                        pattern: CHECK_percent,
                                        message: '比例格式不正确',
                                    }];
                            },
                        },
                    }),
                    render: (test, rowData, index) => {
                        const { brokerageTag } = rowData;
                        const val = brokerageTag === 0 ? rowData.brokerageY : test;
                        return brokerageTag !== 2 ?
                            (<span>
                  {`${val}`.toLowerCase() === 'null' ? '0.00' : val}
                  </span>) :
                            (<a onClick={() => {
                                const list = JSON.parse(rowData.brokerageFixStep || '[]');
                                this.showCostDetail({
                                    type: 'brokerage',
                                    list,
                                });
                            }}>
                  查看
                </a>);
                    },
                },
                {
                    title: '服务费/元',
                    width: 100,
                    align: 'left',
                    dataIndex: 'commissionY',
                    onCell: (rowData, index) => ({
                        td: {
                            editable: this.judgeSessionState(0) && this.isEdit(rowData.goodsId) && rowData.commissionTag !== 2,
                            tdType: 'editable',
                            rowData,
                            dataIndex: 'commissionY',
                            checkRule: () => [
                                {
                                    pattern: CHECK_Money7,
                                    message: '请输入不超过七位数的整百数',
                                },
                            ],
                        },
                    }),
                    render: (test, rowData) => {
                        const { commissionTag } = rowData;
                        return commissionTag !== 2 ?
                            (<span>
                  {`${test}`.toLowerCase() === 'null' ? '0.00' : test}
                  </span>) :
                            (<a onClick={() => {
                                const list = JSON.parse(rowData.commissionFixStep || '[]');
                                this.showCostDetail({
                                    type: 'commission',
                                    list,
                                });
                            }}>
                  查看
                </a>);
                    },
                },
                {
                    title: '最高价/元',
                    width: 80,
                    align: 'left',
                    dataIndex: 'highestOfferY',
                },
                {
                    title: '拍卖时间',
                    align: 'left',
                    width: 110,
                    dataIndex: 'beginTime',
                    render: (beginTime, rowData) => {
                        return rowData.auctionStatus === 7 ?
                            <span>{fontEndConfig.noValueReplace}</span> : (<div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                        }}>
                  <div>
                    <span>{beginTime.split(' ')[0]}&nbsp;&nbsp;</span>
                  </div>
                  <div>
                    <span>{beginTime.split(' ')[1]}</span>
                  </div>
                </div>);
                    },
                },
            ],
            tableOperate: [{
                    title: '操作',
                    width: 90,
                    align: 'left',
                    dataIndex: 'label',
                    onCell: (rowData, index) => ({
                        td: {
                            tdType: 'operate',
                            rowData,
                            index,
                            sessionForm: this.props.Form,
                        },
                    }),
                }],
            editingKey: '',
            costType: {
                brokerage: {
                    title: '佣金',
                    desc: '区间值为大于等于下限，小于上限',
                },
                commission: {
                    title: '服务费',
                    desc: '区间值为大于等于下限，小于上限',
                },
            },
            updateInterval: 30000,
            transferList: [
                {
                    key: 'contactAddress',
                    label: '看车地址',
                },
                {
                    key: 'transferType',
                    label: '过户方式',
                    render(transferType) {
                        let transferTypeStr = transferType;
                        switch (transferType) {
                            case 1:
                                transferTypeStr = '车易拍过户';
                                break;
                            case 2:
                                transferTypeStr = '卖家过户';
                                break;
                            case 3:
                                transferTypeStr = '买家过户';
                                break;
                        }
                        return <span>{transferTypeStr}</span>;
                    },
                },
                {
                    key: 'transferAddress',
                    label: '指定过户地址',
                    render(transferAddress) {
                        return (<span>
                {transferAddress === fontEndConfig.noValueReplace ? '否' : '是'}
              </span>);
                    },
                },
                {
                    key: 'transferAddress',
                    label: '过户地址',
                },
                {
                    key: 'invoicePrice',
                    label: '指定开票',
                    render(invoicePrice) {
                        // debugger;
                        return (<span>
                {getDataType(invoicePrice) === 'Number' ?
                            invoicePrice === -1 ? '不需要' : '需要'
                            :
                                invoicePrice}
            </span>);
                    },
                },
                {
                    key: 'nonlocalTag',
                    label: '过户类型',
                    render(nonlocalTag) {
                        let nonlocalTagStr = nonlocalTag;
                        switch (nonlocalTag) {
                            case 1:
                                nonlocalTagStr = '本地';
                                break;
                            case 2:
                                nonlocalTagStr = '外迁';
                                break;
                            case 3:
                                nonlocalTagStr = '不限';
                                break;
                        }
                        return <span>{nonlocalTagStr}</span>;
                    },
                },
                {
                    key: 'localProcedures',
                    label: '过户手续（本地）',
                    render(localProcedures) {
                        const listVal = {
                            1: '原购车发票',
                            2: '过户票',
                            3: '原过户票',
                            4: '原登记证',
                            5: '原行驶本',
                            6: '卖家身份证',
                            7: '买家身份证',
                            8: '变更后行驶本',
                            9: '变更后登记证',
                            11: '协议',
                            12: '服务授权书',
                            13: '档案',
                        };
                        const localProceduresList = localProcedures.split(',');
                        const valShow = localProceduresList.map((val) => {
                            return listVal[val];
                        });
                        return <span>{valShow.join(' ') || localProcedures}</span>;
                    },
                },
                {
                    key: 'emigrateProcedures',
                    label: '过户手续（外迁）',
                    render(emigrateProcedures) {
                        const listVal = {
                            1: '原购车发票',
                            2: '过户票',
                            3: '原过户票',
                            4: '原登记证',
                            5: '原行驶本',
                            6: '卖家身份证',
                            7: '买家身份证',
                            8: '变更后行驶本',
                            9: '变更后登记证',
                            11: '协议',
                            12: '服务授权书',
                            13: '档案',
                        };
                        const emigrateProceduresList = emigrateProcedures.split(',');
                        const valShow = emigrateProceduresList.map((val) => {
                            return listVal[val];
                        });
                        return <span>{valShow.join(' ') || emigrateProcedures}</span>;
                    },
                },
            ],
        };
        this.isEdit = this.isEdit.bind(this);
        this.addCar = this.addCar.bind(this);
        this.addCarBefore = this.addCarBefore.bind(this);
        this.sortIndexBefore = this.sortIndexBefore.bind(this);
        this.sortIndex = this.sortIndex.bind(this);
        this.showTransferDetail = this.showTransferDetail.bind(this);
    }
    // desc 判断场次类型
    judgeSessionState(sessionState) {
        const { roundStatus } = this.props.session;
        return roundStatus === sessionState;
    }
    // desc 展示过户信息
    showTransferDetail(goodsId) {
        const list = this.state.transferList;
        dispatch.session.getTransfer({
            params: {
                goodsId,
            },
            callback: (data = {}) => {
                const valData = dealListValueShow({
                    gistData: list,
                    data: [data],
                })[0];
                showInfo('userDefine', {
                    title: '成交信息',
                    describle: '',
                    content: () => {
                        return (<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                {list.map((item, index) => {
                            return (<Form.Item style={{
                                width: '100%',
                                marginBottom: 0,
                            }} labelCol={{
                                span: 8,
                                offset: 2,
                            }} wrapperCol={{
                                span: 12,
                            }} labelAlign={'left'} colon={false} key={index} label={item.label}>
                        {item.render ? item.render(valData[item.key]) : <span>{valData[item.key]}</span>}
                      </Form.Item>);
                        })}
                {list.length === 0 && (<span>暂无</span>)}
                <Button style={{
                            marginTop: '20px',
                        }} type={'primary'} onClick={() => {
                            dispatch.info.RESET_HIDE();
                        }}>
                  确定
                </Button>
              </div>);
                    },
                });
            },
        });
    }
    // desc 展示【佣金，服务费】详情
    showCostDetail({ type, list }) {
        const { title, desc } = this.state.costType[type];
        showInfo('userDefine', {
            title,
            describle: desc,
            content: () => {
                return (<div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
            {list.map((item, index) => {
                    return (<Form.Item style={{
                        width: '100%',
                        marginBottom: 0,
                    }} labelCol={{
                        span: 12,
                    }} colon={false} key={index} label={this.dealLadderLabel(item)}>
                    <span>{`${title}${item.value}元`}</span>
                  </Form.Item>);
                })}
            {list.length === 0 && (<span>暂无</span>)}
          </div>);
            },
        });
    }
    // desc 处理【佣金，服务费】展示
    dealLadderLabel({ min, max }) {
        if (min === 0 || min === '0.00') {
            return `${max}万以下`;
        }
        if (max === -1 || max === '-1.00') {
            return `${min}万及以上`;
        }
        return `${min}万-${max}万`;
    }
    // desc 根据表格第一行数据 判断【佣金单位】
    getBrokerageType(carData) {
        const { carTable, brokerageUnit } = this.state;
        if (carData.length === 0) {
            return;
        }
        let str = '/元';
        switch (carData[0].brokerageTag) {
            case 1:
                str = '/%';
                break;
            default:
                break;
        }
        carTable.forEach((v) => {
            (v.dataIndex === 'brokerage') && (v.title = `佣金${str}`);
        });
        setTimeout(() => {
            str !== brokerageUnit && this.setState({
                carTable,
                brokerageUnit: str,
            });
        });
    }
    // desc 判断是否在编辑状态
    isEdit(key) {
        const { editingKey } = this.props.session;
        const index = editingKey.findIndex((v) => v === key);
        return index !== -1;
    }
    // desc 展示【添加车辆modal】- 场次车辆数小于999
    addCar() {
        const { carData } = this.props.session;
        if (carData.length < 999) {
            dispatch.session.queryAddModalTable({ pageIndex: 1 });
            dispatch.session.SHOW_ADD_MODAL();
        }
        else {
            message.warning('场次最多可添加999辆车');
        }
    }
    addCarBefore() {
        const { roundStatus, formData } = this.props.session;
        const { auctionMode } = formData;
        if (roundStatus === 2 && auctionMode !== 2) {
            dispatch.session.isAuctionLast({})
                .then((isLast) => {
                isLast ? Modal.warn({
                    title: '车辆正在拍最后一辆车，不允许加车',
                }) : this.addCar();
            });
        }
        else if ((roundStatus === 2 && auctionMode === 2) || (roundStatus === 5 && (auctionMode === 1011 || auctionMode === 1021))) {
            dispatch.session.isTwoMinLeft({}).then((isMore) => {
                !isMore ? Modal.warn({
                    title: '场次马上结束，不支持操作',
                }) : this.addCar();
            });
        }
        else {
            this.addCar();
        }
    }
    // desc 按序号对【车辆排序】
    sortIndex() {
        const { carData, editIndex } = this.props.session;
        if (editIndex) {
            this.props.form.validateFields()
                .then((data) => {
                dispatch.session.sortIndex(data);
            })
                .catch((err) => {
                const errList = Object.keys(err.errors);
                const needScrollGoodsId = errList[0];
                const scrollIndex = carData.findIndex((item) => {
                    return item.goodsId === needScrollGoodsId;
                }) + 1;
                const scrollTable = document.getElementsByClassName('ant-table-body')[0];
                const scrollRow = document.getElementsByClassName('ant-table-row')[0];
                // @ts-ignore
                scrollTable.scrollTop = scrollIndex * (scrollRow.clientHeight || 150);
            });
        }
        else {
            dispatch.session.SET_STATE({
                editIndex: !editIndex,
            });
        }
    }
    sortIndexBefore() {
        const { roundStatus, formData } = this.props.session;
        const { auctionMode } = formData;
        if ((roundStatus === 2 && auctionMode === 2) || (roundStatus === 5 && (auctionMode === 1011 || auctionMode === 1021))) {
            dispatch.session.isTwoMinLeft({}).then((isMore) => {
                !isMore ? Modal.warn({
                    title: '场次马上结束，不支持操作',
                }) : this.sortIndex();
            });
        }
        else {
            this.sortIndex();
        }
    }
    update() {
        const { updateInterval } = this.state;
        if (!this.updateTimer) {
            this.updateTimer = setInterval(() => {
                dispatch.session.getGoodsDetail({});
                dispatch.session.SET_STATE({
                    editingKey: [],
                });
            }, updateInterval);
        }
    }
    componentWillUnmount() {
        clearInterval(this.updateTimer);
        this.updateTimer = null;
    }
    renderSort() {
        const { roundStatus, formData, editIndex, isDelayTender } = this.props.session;
        let needSort = false;
        switch (formData.auctionMode) {
            case 1:
                // 现场拍 -> 场次类型为待发拍和预展中
                if (roundStatus === 0 || roundStatus === 1) {
                    needSort = true;
                }
                break;
            case 2:
                // 暗拍 -> 场次类型不为已撤销，已结束
                if ((roundStatus !== 3 || roundStatus !== 4)) {
                    needSort = true;
                }
                break;
            case 1001:
                // 车道拍 -> 场次类型为待发拍和预展中
                if ((roundStatus === 0 || roundStatus === 1)) {
                    needSort = true;
                }
                break;
            case 1011:
            case 1021:
                // 超级拍 -> 场次类型为待发拍和预展中和投标中
                if (roundStatus === 0 || roundStatus === 1 || roundStatus === 5) {
                    if (roundStatus === 5 && isDelayTender) {
                        needSort = false;
                    }
                    else {
                        needSort = true;
                    }
                }
                break;
        }
        return needSort && (<div>
        <Button className={clazz(styles.operateButton, styles.sortButton, { [styles.sortButton_active]: editIndex })} style={{
            marginRight: 30,
        }} size={'small'} onClick={() => {
            this.sortIndexBefore();
        }}>
          {editIndex ? (<Icon type="check-circle"/>) : (<Icon type="swap" rotate={90}/>)}
          {editIndex ? '保存排序' : '批量排序'}
        </Button>
        
        
        
      </div>);
    }
    renderExport() {
        const { roundStatus, formData } = this.props.session;
        let needExport = false;
        switch (formData.auctionMode) {
            case 1:
            case 2:
            case 1001:
            case 1011:
            case 1021:
                if (roundStatus === 0 || roundStatus === 1) {
                    needExport = true;
                }
                break;
        }
        return needExport && (<>
        <Button className={styles.export_out} onClick={() => {
            dispatch.session.exportOutSort({});
        }}>
          导出排序
        </Button>
        <Upload showUploadList={false} customRequest={(info) => {
            const formData = new FormData();
            const { roundId } = this.props.session;
            formData.append('file', info.file);
            formData.append('roundId', roundId);
            dispatch.session.exportInSort(formData);
        }}>
          <Button type={'primary'} className={styles.export_in}>
            导入排序
          </Button>
        </Upload>
      </>);
    }
    renderAdd() {
        const { formData, isDelayTender, roundStatus } = this.props.session;
        let needAdd = false;
        switch (formData.auctionMode) {
            case 1:
                // 现场拍 ->
                needAdd = true;
                break;
            case 2:
                // 暗拍 ->
                needAdd = true;
                break;
            case 1001:
                // 车道拍 ->
                needAdd = true;
                break;
            case 1011:
            case 1021:
                // 超级拍 -> 场次类型为待发拍和预展中和投标中
                if (roundStatus === 0 || roundStatus === 1 || roundStatus === 5) {
                    if (roundStatus === 5 && isDelayTender) {
                        needAdd = false;
                    }
                    else {
                        needAdd = true;
                    }
                }
                break;
        }
        return needAdd && (<Button className={styles.operateButton} type={'primary'} size={'small'} onClick={this.addCarBefore}>
        <Icon type="plus"/>添加车辆
      </Button>);
    }
    render() {
        const { carData, rowKey, pageState, roundStatus, formData, loadingCar } = this.props.session;
        const { carTable, tableOperate } = this.state;
        pageState === 1 && roundStatus === 2 && formData.auctionMode !== 2 && this.update();
        this.getBrokerageType(carData);
        const tableColumns = [...carTable, ...tableOperate];
        return (<React.Fragment>
        <div className={styles.addCarTitle}>
          发拍车辆&nbsp;
          <span style={{ color: '#f5222d' }}>*</span>
        </div>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 19,
            justifyContent: 'space-between',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
        }}>
            {
        // 页面类型不为详情
        pageState !== 2 && (roundStatus !== 3 && roundStatus !== 4) && this.renderSort()}
            {
        // 页面类型不为详情 && （场次类型不为结束 && 场次类型不为撤销）
        pageState !== 2 && (roundStatus !== 3 && roundStatus !== 4) && this.renderAdd()}
          </div>
          <div>
            {
        // 页面类型不为详情
        pageState !== 2 && (roundStatus !== 3 && roundStatus !== 4) && this.renderExport()}
          </div>
        </div>
        <Table className={'draw_table_all_border'} loading={loadingCar} rowKey={rowKey} columns={tableColumns} dataSource={dealListValueShow({
            gistData: tableColumns,
            data: carData,
        })} components={{
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        }} pagination={false} scroll={{
            x: 1100,
            y: 700,
        }}/>
        <AddCarModal />
      </React.Fragment>);
    }
}
const AddCarTableForm = Form.create({
    onFieldsChange: (props, changedFields, allFields) => {
        dispatch.session.SET_STATE({
            validateIndexList: allFields,
        });
    },
})(AddCarTable);
export default connect(mapStateToProps)(AddCarTableForm);
